import { DialogContent, Grid, useMediaQuery, useTheme } from '@mui/material';
import type { GridSize } from '@mui/material/Grid';
import { useMemo } from 'react';

export function TwoPaneModalContent({
  leftContent,
  rightContent,
  leftDesktopWidth,
  rigthDesktopWidth,
  flexibleWidthPane
}: {
  // Desktop column widths in Grid units. Typed as number because we do arithmetic on them.
  leftDesktopWidth: number;
  rigthDesktopWidth: number;
  flexibleWidthPane?: 'left' | 'right';
  leftContent(): JSX.Element;
  rightContent(): JSX.Element;
}) {
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down('sm'));
  const isSM = useMediaQuery(theme.breakpoints.down('sm'));
  const isLarge = useMediaQuery(theme.breakpoints.up('sm'));

  // Widths are computed
  const [leftWidth, rigthWidth] = useMemo(
    () => [
      setDesktopWidth('left', leftDesktopWidth, isXS, isSM, flexibleWidthPane),
      setDesktopWidth('right', rigthDesktopWidth, isXS, isSM, flexibleWidthPane)
    ],
    [leftDesktopWidth, rigthDesktopWidth, isSM, isXS, flexibleWidthPane]
  );

  // Min height is computed and set only for large screens
  const minHeight = useMemo(() => (isLarge ? '400px' : undefined), [isLarge]);

  return (
    <>
      <DialogContent style={{ fontSize: '14px', padding: 0, minHeight }}>
        <Grid container sx={{ flexDirection: isXS ? 'column' : 'row' }}>
          <Grid
            style={{
              borderRight: isXS ? undefined : '1px solid #EBEDF2',
              borderBottom: isXS ? '1px solid #EBEDF2' : undefined,
              padding: '16px 0'
            }}
            size={leftWidth}
          >
            {leftContent()}
          </Grid>
          <Grid style={{ padding: '16px 0' }} size={rigthWidth}>
            {rightContent()}
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}

function setDesktopWidth(
  pane: 'left' | 'right',
  providedWidth: number,
  isXS: boolean,
  isSM: boolean,
  flexibleWidthPane?: 'left' | 'right'
): Exclude<GridSize, 'auto'> {
  if (isXS) {
    return 12;
  }
  if (isSM && flexibleWidthPane === undefined && providedWidth < 12) {
    if (flexibleWidthPane === pane) {
      return (providedWidth - 1) as Exclude<GridSize, 'auto'>;
    }
    return (providedWidth + 1) as Exclude<GridSize, 'auto'>;
  }
  return providedWidth;
}
